import React from 'react';
import withRecaptcha from './withRecaptcha';
import { withHCaptcha } from './withHCaptcha';

export const withCaptcha = WrappedComponent => {
    const CaptchaWrapper = ({
        readyHCaptchaToken,
        readyRecaptchaToken,
        isHCaptchaActive,
        isReCaptchaActive,
        renderHCaptchaTermsAndConditions,
        renderReCaptchaTermsAndConditions,
        ...props
    }) => {
        const readyCaptchaToken = callback => {
            if (isHCaptchaActive) {
                readyHCaptchaToken(callback);
                return;
            }

            if (isReCaptchaActive) {
                readyRecaptchaToken(callback);
                return;
            }

            callback(null);
        };

        const renderTermsAndConditions = () => {
            if (isHCaptchaActive) {
                return renderHCaptchaTermsAndConditions();
            }

            if (isReCaptchaActive) {
                return renderReCaptchaTermsAndConditions();
            }
        };

        return (
            <WrappedComponent
                {...props}
                readyCaptchaToken={readyCaptchaToken}
                renderTermsAndConditions={renderTermsAndConditions}
            />
        );
    };

    return withHCaptcha(withRecaptcha(CaptchaWrapper));
};
